import {
  KISSFLOW_LOGIN_ROUTES,
  PUBLIC_ROUTES,
  DIRECT_PRIVATE_ROUTES
} from "./kissflow/index.jsx";
import { PORTAL_LOGIN_ROUTES } from "./portal/index.jsx";

let accountDetails = window.accountDetails || {};
let isPortal = accountDetails.IsPortal;

let LOGIN_ROUTES = [...KISSFLOW_LOGIN_ROUTES];

if (isPortal) {
  LOGIN_ROUTES = [...PORTAL_LOGIN_ROUTES];
}

export { LOGIN_ROUTES, PUBLIC_ROUTES, DIRECT_PRIVATE_ROUTES };
